export default {
  "booking.verifyTitle": "Confirm your email to book",
  "booking.verifyDesc": "We sent you a verification link when you created your account. Open it, then come back to this page.",
  "booking.verifyResend": "Resend link",
  "booking.verifySending": "Sending…",
  "booking.verifySent": "Done, check your inbox (and your spam folder).",
  "booking.verifyResendError": "We couldn't resend the link. Please try again later.",
  "booking.title": "Book your experience",
  "booking.subtitle": "Complete your booking in 3 simple steps",
  "booking.step1": "Details",
  "booking.step2": "Payment",
  "booking.step3": "Confirmation",
  "booking.tourSummary": "Tour summary",
  "booking.date": "Date",
  "booking.time": "Time",
  "booking.guests": "Travelers",
  "booking.adults": "Adults",
  "booking.children": "Children",
  "booking.contactInfo": "Contact information",
  "booking.firstName": "First name",
  "booking.lastName": "Last name",
  "booking.email": "Email",
  "booking.phone": "Phone",
  "booking.specialRequests": "Special requests",
  "booking.specialRequestsPlaceholder": "Any allergies, dietary restrictions, or special requests?",
  "booking.priceSummary": "Price summary",
  "booking.adultsTotal": "Adults",
  "booking.childrenTotal": "Children",
  "booking.subtotal": "Subtotal",
  "booking.taxes": "Taxes (16% VAT)",
  "booking.total": "Total",
  "booking.mpTitle": "Pay with Mercado Pago",
  "booking.mpDesc": "You will be redirected to Mercado Pago to complete your payment securely",
  "booking.mpAccepted": "We accept",
  "booking.mpCard": "Credit or debit card",
  "booking.mpOxxo": "OXXO",
  "booking.mpSpei": "SPEI / Bank transfer",
  "booking.mpSecure": "Payment securely processed by Mercado Pago",
  "booking.mpPayButton": "Pay with Mercado Pago",
  "booking.payWith": "Pay with",
  "booking.cardNumber": "Card number",
  "booking.cardHolder": "Card holder",
  "booking.expiry": "Expiry",
  "booking.cvv": "CVV",
  "booking.termsNote": "By completing the booking you agree to our",
  "booking.termsLink": "terms and conditions",
  "booking.back": "Back",
  "booking.continue": "Continue",
  "booking.confirm": "Confirm booking",
  "booking.processing": "Processing...",
  "booking.confirmedTitle": "Booking confirmed!",
  "booking.confirmedDesc": "We have sent the details to your email",
  "booking.bookingId": "Booking ID",
  "booking.download": "Download confirmation",
  "booking.totalPaid": "Total paid",
  "booking.paymentId": "Payment ID",
  "booking.merchantOrderId": "Mercado Pago Order ID",
  "booking.verifyingTitle": "Verifying payment...",
  "booking.verifyingDesc": "Please wait while we confirm your payment with Mercado Pago",
  "booking.successTitle": "Payment confirmed!",
  "booking.successDesc": "Your booking is confirmed. We sent the details to your email.",
  "booking.pendingTitle": "Payment pending",
  "booking.pendingDesc": "We are waiting for payment confirmation. This may take a few minutes for methods like OXXO or SPEI.",
  "booking.rejectedTitle": "Payment not completed",
  "booking.rejectedDesc": "The payment was declined or cancelled.",
  "booking.rejectedHelp": "You can try again with a different payment method.",
  "booking.tryAgain": "Try again",
  "booking.backToHome": "Back to home",
  "booking.viewBookings": "View my bookings",
  "booking.cancel": "Cancel booking",
  "booking.notFound": "Tour not found",
  "booking.backToTours": "Back to tours",
  "booking.loadError": "We could not load the tour. Please try again.",
  "booking.createError": "We could not create the booking. Please try again.",
  "booking.required": "Required field",
  "booking.invalidEmail": "Invalid email",
  "booking.invalidPhone": "Invalid phone",
  "booking.securePayment": "Secure payment with SSL encryption",
  "booking.instantConfirm": "Instant confirmation",
  "booking.freeCancel": "Free cancellation up to 24h before",
  "booking.perPerson": "per person",
  "booking.perChild": "per child",
  "booking.totalGuests": "Total travelers",
  "booking.guest": "traveler",
  "booking.guestsPlural": "travelers",

  // EN parity: payment status, voucher and order screens
  "booking.confirmDesc": "Your booking has been confirmed successfully",
  "booking.confirmTitle": "Booking confirmed!",
  "booking.downloadPdf": "Download PDF",
  "booking.failedDesc": "We couldn't process your payment. Please try again.",
  "booking.failedTitle": "Payment failed",
  "booking.failReason1": "The card was declined by the bank",
  "booking.failReason2": "Insufficient funds",
  "booking.failReason3": "Incorrect payment details",
  "booking.myBookings": "My bookings",
  "booking.orderDetails": "Order details",
  "booking.paymentSubtitle": "Complete your payment securely",
  "booking.paymentTitle": "Payment",
  "booking.processingDesc": "We're connecting to Mercado Pago...",
  "booking.processingTitle": "Processing payment",
  "booking.providerContact": "Provider contact",
  "booking.secureConnection": "Secure connection",
  "booking.showQr": "Show this QR code when your tour starts",
  "booking.viewVoucher": "View voucher",
  "booking.voucherPaid": "Paid",
  "booking.voucherTitle": "Booking voucher",
  "booking.whatHappened": "What happened?",

  // Availability picker
  "booking.weekdays": ["M", "T", "W", "T", "F", "S", "S"],
  "booking.spotsTitle_one": "{{count}} spot",
  "booking.spotsTitle_other": "{{count}} spots",
  "booking.spotsAvailable_one": "{{count}} spot available",
  "booking.spotsAvailable_other": "{{count}} spots available",
  "booking.availabilityHelp_one": "Only days with enough capacity for {{count}} guest are selectable.",
  "booking.availabilityHelp_other": "Only days with enough capacity for {{count}} guests are selectable.",
  "booking.maxGuests": "Max {{count}}",

  // Coupons
  "booking.couponLabel": "Discount code",
  "booking.couponPlaceholder": "e.g. BAJA10",
  "booking.couponApply": "Apply",
  "booking.couponRemove": "Remove",
  "booking.couponApplied": "Coupon applied",
  "booking.couponInvalid": "Invalid coupon.",
  "booking.couponError": "We couldn't validate the coupon.",
  "booking.discount": "Discount",
  "booking.couponReason.NOT_FOUND": "This coupon doesn't exist.",
  "booking.couponReason.INACTIVE": "This coupon is no longer active.",
  "booking.couponReason.OUTSIDE_WINDOW": "This coupon isn't valid for this date.",
  "booking.couponReason.REDEMPTIONS_EXHAUSTED": "This coupon has reached its usage limit.",
  "booking.couponReason.INVALID": "Invalid coupon.",

  // Voucher
  "booking.voucherNotFound": "We couldn't find the voucher for this booking.",
  "booking.backToBookings": "Back to my bookings",
  "booking.voucherCancelled": "Cancelled",
  "booking.voucherPending": "Pending",
  "booking.paymentMethod": "Payment method",
};